import React from "react";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import { Tooltip } from "../../shared/Tooltip/Tooltip";
import { LockClosedIcon } from "../../assets/Icons/LockClosedIcon";

export const FEATURE_LOCK_REASON = {
  acceleratorRequired: "acceleratorRequired",
};

export const FeatureLock = ({ reason, iconWidth }) => {
  const { tCommon: t } = useAppTranslation.Common();

  const messageByReason = {
    [FEATURE_LOCK_REASON.acceleratorRequired]: t(
      "featureLock.acceleratorRequired",
    ),
  };

  return (
    <Tooltip id={`feature-lock-${reason}`} text={messageByReason[reason]}>
      <LockClosedIcon width={iconWidth} />
    </Tooltip>
  );
};
